/*
		Cosmos Transaction builder

 */
const secp256k1 = require('secp256k1')
const sha256 = require("crypto-js/sha256")


const TAG = " | tx-builder | "
let CHAIN_ID=process.env['ATOM_CHAIN']

let ATOM_MAX_GAS="100000"
let ATOM_TX_FEE="100"

module.exports = {
    createTransfer: function (from,to,amount) {
        return create_transfer_tx(from,to,amount);
    },
    sign: function (jsonTx, wallet, sequence, account_number, chain_id) {
        return sign_transaction(jsonTx, wallet, sequence, account_number, chain_id);
    },
    prepareSignBytes: function (jsonTx) {
        return prepair_transaction(jsonTx);
    },
    createSignMessage: function (jsonTx,sequence, account_number, chain_id) {
        return create_sign_message(jsonTx,jsonTx,sequence, account_number, chain_id);
    },
    signWithPrivateKey: function (signMessage, privateKey) {
        return sign_with_privkey(signMessage, privateKey);
    },
    formatSignature: function (signature, sequence, account_number, publicKey) {
        return format_signature(signature, sequence, account_number, publicKey);
    },
    createBroadcastBody: function (signedTx) {
        return create_broadcast_body(signedTx);
    },
    createSignedTx: function (tx, signature) {
        return create_signed_tx(tx, signature);
    },
}

const create_transfer_tx = async function(from,to,amount){
    let tag = TAG+" | create_transfer_tx | "
    try{
        //
        let amountU = amount * 1000000
        amountU = parseInt(amountU)
        if(!amountU || amountU === 0 || amountU < 0) throw Error("104: invalid amount!")

        //log.debug(tag,"amountU",amountU)
        amountU = amountU.toString()

        //
        let tx = {
            msg:[
                {
                    type:"cosmos-sdk/MsgSend",
                    value:{
                        "from_address":from,
                        "to_address":to,
                        "amount":[
                            {
                                "denom":"uatom",
                                "amount":amountU
                            }
                        ]
                    }
                }
            ],
            fee: { amount: [{ denom: `uatom`, amount: ATOM_TX_FEE }], gas: ATOM_MAX_GAS },
            signatures: null,
            memo: `sent from the citadel`
        }

        return tx
    }catch(e){
        console.error(e)
        throw Error(e)
    }
}

let create_signed_tx = function(tx, signature) {
    if(!tx.signatures) tx.signatures = []
    tx.signatures = [signature]
    return tx
}

let create_broadcast_body = function(signedTx) {
    return JSON.stringify({
        tx: signedTx,
        mode: returnType = `sync`
    })
}



let prepareSignBytes = function(jsonTx) {
    if (Array.isArray(jsonTx)) {
        return jsonTx.map(prepareSignBytes)
    }

    // string or number
    if (typeof jsonTx !== `object`) {
        return jsonTx
    }

    const sorted = {}
    Object.keys(jsonTx)
        .sort()
        .forEach(key => {
            if (jsonTx[key] === undefined || jsonTx[key] === null) return

            sorted[key] = prepareSignBytes(jsonTx[key])
        })
    return sorted
}


const sign_transaction = async function(jsonTx, wallet, sequence, account_number, chain_id){
    let tag = TAG+" | sign_transaction | "
    try{
        //const { sequence, account_number } = requestMetaData

        const signMessage = await create_sign_message(jsonTx, sequence, account_number, chain_id)

        const signatureBuffer = await sign_with_privkey(signMessage, wallet.privateKey)

        const pubKeyBuffer = Buffer.from(wallet.publicKey, `hex`)

        return format_signature(
            signatureBuffer,
            pubKeyBuffer
        )
    }catch(e){
        console.error(e)
        throw Error(e)
    }
}


const prepair_transaction = async function(jsonTx){
    let tag = TAG+" | prepair_transaction | "
    try{
        if (Array.isArray(jsonTx)) {
            return jsonTx.map(prepareSignBytes)
        }

        // string or number
        if (typeof jsonTx !== `object`) {
            return jsonTx
        }

        const sorted = {}
        Object.keys(jsonTx)
            .sort()
            .forEach(key => {
                if (jsonTx[key] === undefined || jsonTx[key] === null) return

                sorted[key] = prepareSignBytes(jsonTx[key])
            })
        return sorted
    }catch(e){
        console.error(e)
        throw Error(e)
    }
}


const create_sign_message = async function(jsonTx,sequence, account_number, chain_id){
    let tag = TAG+" | create_sign_message | "
    try{
        //{ sequence, account_number, chain_id }

        // sign bytes need amount to be an array
        const fee = {
            amount: jsonTx.fee.amount || [],
            gas: jsonTx.fee.gas
        }

        return JSON.stringify(
            prepareSignBytes({
                fee,
                memo: jsonTx.memo,
                msgs: jsonTx.msg, // weird msg vs. msgs
                sequence,
                account_number,
                chain_id
            })
        )

    }catch(e){
        console.error(e)
        throw Error(e)
    }
}


const sign_with_privkey = async function(signMessage, privateKey){
    let tag = TAG+" | sign_with_privkey | "
    try{
        console.log(tag,"signMessage: ",typeof(signMessage))
        console.log(tag,"signMessage: ",signMessage)

        const signHash = Buffer.from(sha256(signMessage).toString(), `hex`)
        const { signature } = secp256k1.sign(signHash, Buffer.from(privateKey, `hex`))

        //log.debug(tag,"signature: ",signature)

        return signature

    }catch(e){
        console.error(e)
        throw Error(e)
    }
}

// signature, sequence, account_number, publicKey
const format_signature = async function(signature, publicKey){
    let tag = TAG+" | format_signature | "
    try{

        return {
            signature: signature.toString(`base64`),
            pub_key: {
                type: `tendermint/PubKeySecp256k1`, // TODO: allow other keyprpess
                value: publicKey.toString(`base64`)
            }
        }

    }catch(e){
        console.error(e)
        throw Error(e)
    }
}

